















import { TranslateResult }           from 'vue-i18n';
import { computed, defineComponent } from '@vue/composition-api';
import { useGlobals }                from '@/hooks/use-globals';
import { Computed }                  from '@/types';
import cBreadcrumb                   from '@/components/breadcrumb/breadcrumb.component.vue';
import { v3Url }                     from '@/hooks/use-v3-url';

export default defineComponent({
  name: 'vSeasons',
  components: {
    cBreadcrumb,
  },
  setup() {
    const { i18n } = useGlobals();
    const getBreadcrumbTranslation: Computed<TranslateResult> = computed(() => i18n.t('vStrategies.meta.breadcrumb'));
    const dynamicIframeUrl = v3Url('setup/seasons');

    return {
      dynamicIframeUrl,
      getBreadcrumbTranslation,
    };
  },
});
